import React from "react";

export default function DisciplinaryPolicy() {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        Hours of Service Policy Acknowledgement
      </h4>
      <h3>Purpose:</h3>
      <p>
        The philosophy of Shah Transport is to treat all drivers and Contractors
        in a friendly, firm and fair manner. It is further the policy of Shah
        Transport that whenever appropriate the guidelines of Progressive
        Disciplinary Action be exercised.
      </p>
      <h3>Scope:</h3>
      <p>
        Any driver or Owner Operator who has committed an infraction will be
        subject to the following:{" "}
      </p>
      <h3>First offense: Verbal Warning </h3>
      <p>
        This will be documented as a verbal warning and become a part of the
        Driver's / Owner Operators violation file.{" "}
      </p>
      <h3>Second Offense: Written Warning </h3>
      <p>As above documented and placed in violation file. </p>
      <h3>Third Offense: Suspension and or Final Written Warning </h3>
      <p>
        At the company's discretion this is a last chance before termination of
        contract or driver removed from contract.
      </p>
      <h3>Fourth Offense: Termination of employee.</h3>
      <h3>Other:</h3>
      <p>
        Shah Transport, may, at their discretion, determine an incident or
        situation is severe enough to warrant suspension or termination, and
        will exercise that option when necessary.
      </p>
      <p>
        Progressive Disciplinary Action will be executed for breach of company
        policies, procedures, and regulatory violations, out of service
        inspections, collisions, incidents or any other behavior which Shah
        Transport deems unacceptable. I acknowledge that I have read and
        understand the Discipline Policy of Shah Transport
      </p>
    </div>
  );
}
